import { wpAddImageBoxer,wpAddGallaryBoxer } from "./lib/util";
document.addEventListener('DOMContentLoaded', () => {
  wpAddImageBoxer();
  wpAddGallaryBoxer();
});